// Utility function to manage shot list history
export const updateShotListHistory = (
  shotListState,
  setShotListState,
  shotListHistory,
  setShotListHistory,
  historyIndex,
  setHistoryIndex,
  newShotListState
) => {
  // Remove future history states
  console.log("updateShotListHistory shotListHistory", shotListHistory);
  const updatedHistory = [...shotListHistory?.slice(0, historyIndex + 1)];
  
  // Add the current state if it's different from the last state
  if (historyIndex >= 0 && JSON.stringify(shotListState) !== JSON.stringify(updatedHistory[historyIndex])) {
    updatedHistory.push(shotListState);
    setHistoryIndex(historyIndex + 1);
  }
  
  // Add the new state
  updatedHistory.push(newShotListState);
  setShotListState(newShotListState);
  setShotListHistory(updatedHistory);
  setHistoryIndex(historyIndex + 1);
};
